import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from "./Edd Michira Resume.docx";

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span className="intro" style={{ color: darkMode ? "white" : "" }}>
          My Awesome
        </span>
        <span className="top_name">services</span>
        <span>
          I offer full-stack web development services that combine modern design
          with powerful functionality. <br />
          With expertise across both frontend and backend technologies,
          <br /> I build scalable, responsive, and high-performance web
          applications tailored to your needs. <br/> Whether you're looking to launch a portfolio, an e-commerce platform, or a custom web app, 
          <br/>I provide end-to-end solutions with clean code and a focus on performance.
          <br />
          <span className="name">Frontend Development:</span> Crafting intuitive
          and responsive user interfaces using <br /> HTML, CSS, Tailwind CSS,
          Sass, JavaScript, React, and Next.js to ensure a seamless user
          experience on all devices.
          <br />
          <span className="name"> Backend Development:</span> Building robust
          and secure server-side logic with <br />
          Express and Prisma, enabling fast APIs and smooth database
          interactions.
          <br />
          <span className="name"> Databases & Storage:</span> Efficient data
          handling and storage using
          <br /> MongoDB, SQL, Firebase, and Supabase, <br />
          allowing your applications to scale reliably and perform consistently.
        </span>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Backend"}
            detail={"Express, Prisma"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Frontend"}
            detail={"Html, Css, Tailwind, Sass, JavaScript, React, Next"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Databases"}
            detail={"Mongo Db, Firebase, Sql"}
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
